var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table tablerow mb-3",
        attrs: { "aria-labelledby": _vm.labelledBy }
      },
      [
        _c("thead", [
          _c("tr", [
            _c(
              "th",
              {
                staticClass: "w-110",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_0"
                }
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SummaryReport.TargetGroup.DistributionHeading")
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_1"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages0to5"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_2"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages6to17"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_3"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages18to24"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_4"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages25to35"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_5"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages36to45"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_6"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages46to55"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_7"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages56to65"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_8"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages66to75"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title + _vm.componentIndex + "_" + _vm.tableIndex + "_9"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.Ages76plus"
                      )
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "w-120 right",
                attrs: {
                  id:
                    _vm.title +
                    _vm.componentIndex +
                    "_" +
                    _vm.tableIndex +
                    "_10"
                }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.Distribution.AllAges"
                      )
                    )
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("age-distribution-table-row", {
              attrs: {
                title:
                  "ContinuousReport.TargetGroupsAndOperation.Distribution.Men",
                row: _vm.distribution.men,
                labelledBy:
                  _vm.title + _vm.componentIndex + "_" + _vm.tableIndex
              }
            }),
            _vm._v(" "),
            _c("age-distribution-table-row", {
              attrs: {
                title:
                  "ContinuousReport.TargetGroupsAndOperation.Distribution.Women",
                row: _vm.distribution.women,
                labelledBy:
                  _vm.title + _vm.componentIndex + "_" + _vm.tableIndex
              }
            }),
            _vm._v(" "),
            _c("age-distribution-table-row", {
              attrs: {
                title:
                  "ContinuousReport.TargetGroupsAndOperation.Distribution.Other",
                row: _vm.distribution.other,
                labelledBy:
                  _vm.title + _vm.componentIndex + "_" + _vm.tableIndex
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c("td", { staticClass: "disabled-background" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("Total")))])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages0to5Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages6to17Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages18to24Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages25to35Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages36to45Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages46to55Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages56to65Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages66to75Total)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.ages76plusTotal)))
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right disabled-background" }, [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatNumber")(_vm.grandTotal)))
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }